import receptionImage1 from '../images/receptions/reception1.JPG'
import receptionImage2 from '../images/receptions/reception2.jpg'
import receptionImage3 from '../images/receptions/reception3.JPG'
import receptionImage4 from '../images/receptions/reception4.PNG'
import receptionImage5 from '../images/receptions/reception5.PNG'

import weddingImage1 from '../images/wedding/wedding1.PNG'
import weddingImage2 from '../images/wedding/wedding2.JPG'
import weddingImage3 from '../images/wedding/wedding3.jpeg'
import weddingImage4 from '../images/wedding/wedding4.jpg'
import weddingImage5 from '../images/wedding/wedding5.jpg'
import weddingImage6 from '../images/wedding/wedding6.JPEG'

import preweddingImage1 from '../images/prewedding/prewedding1.JPG'
import preweddingImage2 from '../images/prewedding/prewedding2.JPG'
import preweddingImage3 from '../images/prewedding/prewedding3.JPG'
import preweddingImage4 from '../images/prewedding/prewedding4.JPG'
import preweddingImage5 from '../images/prewedding/prewedding5.JPG'
import preweddingImage6 from '../images/prewedding/prewedding6.JPG'
import preweddingImage7 from '../images/prewedding/prewedding7.jpg'

import homedecorImage1 from '../images/homedecor/homedecor1.JPG'
import homedecorImage2 from '../images/homedecor/homedecor2.JPG'
import homedecorImage3 from '../images/homedecor/homedecor3.JPG'
import homedecorImage4 from '../images/homedecor/homedecor4.JPG'
import homedecorImage5 from '../images/homedecor/homedecor5.JPG'
import homedecorImage6 from '../images/homedecor/homedecor6.JPG'
import homedecorImage7 from '../images/homedecor/homedecor7.JPG'
import homedecorImage8 from '../images/homedecor/homedecor8.JPG'

import projectImage1 from '../images/featured/image-2.JPG'
import projectImage2 from '../images/projects/portrait/pic4.jpg'
import projectImage3 from '../images/projects/portrait/pic5.jpg'
import projectImage4 from '../images/projects/square/pic4.jpg'
import projectImage5 from '../images/projects/square/pic9.jpg'
import projectImage6 from '../images/projects/square/pic10.jpg'
import projectImage7 from '../images/projects/square/pic6.jpg'

import projectImage1About from '../images/gallery/pic1.jpg'
import projectImage2About from '../images/gallery/pic2.jpg'
import projectImage3About from '../images/gallery/pic3.jpg'
import projectImage4About from '../images/gallery/pic1.jpg'
import projectImage5About from '../images/gallery/pic2.jpg'
import projectImage6About from '../images/gallery/pic3.jpg'
import projectImage7About from '../images/gallery/pic1.jpg'

import memberImage1 from '../images/our-team5/gurnish.jpg'
import memberImage2 from '../images/our-team5/karan.jpeg'
import memberImage3 from '../images/our-team5/jashan.jpg'
import memberImage4 from '../images/our-team5/roop.jpg'

import productImage1 from '../images/products/WhiteGoldLoveseatSofa.jpg'
import productImageDemo from '../images/products/pic-1.jpg'
import productImage2 from '../images/products/AcrylicCandlebras.jpg'
import productImage3 from '../images/products/CurvedWhiteCherryTrees.jpg'
import productImage4 from '../images/products/GoldCandlebras.png'
import productImage5 from '../images/products/GoldenUrlitubforHaldiCeremony.jpg'
import productImage6 from '../images/products/GreenTree.png'
import productImage7 from '../images/products/JaggoMarqueLetters.png'
import productImage8 from '../images/products/ManjaManjha.jpg'
import productImage9 from '../images/products/PinkWhitePurpleFlowerWall.jpeg'
import productImage10 from '../images/products/PipeDrapeset.jpg'
import productImage11 from '../images/products/StraightCherryTree.png'
import productImage12 from '../images/products/WeddingNeonSign.jpg'
import productImage13 from '../images/products/WhiteFlowerWall.jpeg'
import productImage14 from '../images/products/Acrylic-Table.jpg'


import productImage1ImagesOriginal1 from '../images/products/pic-1.jpg'
import productImage1ImagesOriginal2 from '../images/products/pic-2.jpg'
import productImage1ImagesOriginal3 from '../images/products/pic-3.jpg'
import productImage1ImagesOriginal4 from '../images/products/pic-4.jpg'
import productImage1ImagesOriginal5 from '../images/products/pic-5.jpg'

import productImage6ImagesOriginal from '../images/products/pic-6.jpg'
import productImage7ImagesOriginal from '../images/products/pic-7.jpg'
import productImage8ImagesOriginal from '../images/products/pic-8.jpg'
import productImage9ImagesOriginal from '../images/products/pic-1.jpg'
import productImage10ImagesOriginal from '../images/products/pic-2.jpg'

import productImage1ImagesThumbnail1 from '../images/products/thumb/pic-1.jpg'
import productImage2ImagesThumbnail from '../images/products/thumb/pic-2.jpg'
import productImage3ImagesThumbnail from '../images/products/thumb/pic-3.jpg'
import productImage4ImagesThumbnail from '../images/products/thumb/pic-4.jpg'
import productImage5ImagesThumbnail from '../images/products/thumb/pic-5.jpg'
import productImage6ImagesThumbnail from '../images/products/thumb/pic-1.jpg'
import productImage7ImagesThumbnail from '../images/products/thumb/pic-2.jpg'
import productImage8ImagesThumbnail from '../images/products/thumb/pic-3.jpg'
import productImage9ImagesThumbnail from '../images/products/thumb/pic-4.jpg'
import productImage10ImagesThumbnail from '../images/products/thumb/pic-5.jpg'
import bnrImg from '../images/page_banners/Banner1.JPEG'

export const projectDetails = [
    {
        id: 'Receptions',
        title: 'Receptions',
        subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        heading: 'The standard Lorem Ipsum passage, used since the 1500s',
        paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
        images: [receptionImage1, receptionImage2, receptionImage3, receptionImage4, receptionImage5],
        bnrImg: bnrImg,
        aboutImg: projectImage1About,
        endHeading: 'Creating a sustainable future through building',
        endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    },
    {
        id: 'Weddings',
        title: 'Weddings',
        mainHeading: 'At Sunlight Creationz, we specialize in creating beautiful, personalized decor for all types of weddings, from civil ceremonies to cultural celebrations like Anand Karaj, Mandap, and Nikkah ceremonies. We design elegant setups tailored to each tradition, whether it’s a serene backdrop for a civil union, a graceful mandap for a Hindu wedding, a culturally-rich setup for an Anand Karaj, or an intimate, sophisticated space for a Nikkah. Our team blends cultural traditions with modern aesthetics to bring each couple’s vision to life, making their wedding day unforgettable for them and their guests.',
        subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        heading: 'The standard Lorem Ipsum passage, used since the 1500s',
        paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
        images: [weddingImage1, weddingImage2, weddingImage3, weddingImage4, weddingImage5, weddingImage6],
        bnrImg: bnrImg,
        aboutImg: projectImage2About,
        // subSections: [
        //     {
        //         id: 'Civil',
        //         title: 'Civil',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage4,
        //     },
        //     {
        //         id: 'Anand-Karaj',
        //         title: 'Anand Karaj',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage5,
        //     },
        //     {
        //         id: 'Mandaps',
        //         title: 'Mandaps',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage6,
        //     },
        //     {
        //         id: 'Nikkah',
        //         title: 'Nikkah',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage7,
        //     }
        // ],
        endHeading: 'Creating a sustainable future through building',
        endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    },
    // {
    //     id: 'Civil',
    //     title: 'Weddings - Civil',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage3About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    // {
    //     id: 'Anand-Karaj',
    //     title: 'Weddings - Anand Karaj',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage4About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    // {
    //     id: 'Mandaps',
    //     title: 'Weddings - Mandaps',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage5About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    // {
    //     id: 'Nikkah',
    //     title: 'Weddings - Nikkah',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage6About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    {
        id: 'Home-Decor',
        title: 'Home Decor',
        subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        heading: 'The standard Lorem Ipsum passage, used since the 1500s',
        paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
        images: [homedecorImage1, homedecorImage2, homedecorImage3, homedecorImage4, homedecorImage5, homedecorImage6, homedecorImage7, homedecorImage8],
        bnrImg: bnrImg,
        aboutImg: projectImage7About,
        endHeading: 'Creating a sustainable future through building',
        endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    },
    {
        id: 'Pre-Wedding',
        title: 'Pre-Wedding',
        subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        heading: 'The standard Lorem Ipsum passage, used since the 1500s',
        paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
        images: [preweddingImage1, preweddingImage2, preweddingImage3, preweddingImage4, preweddingImage5, preweddingImage6, preweddingImage7],
        bnrImg: bnrImg,
        aboutImg: projectImage1About,
        endHeading: 'Creating a sustainable future through building',
        endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
        // subSections: [
        //     {
        //         id: 'Sangeet',
        //         title: 'Sangeet',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage4,
        //     },
        //     {
        //         id: 'Jaggo',
        //         title: 'Jaggo',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage5,
        //     },
        //     {
        //         id: 'Haldi-Maiyon',
        //         title: 'Haldi / Maiyon',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage6,
        //     },
        //     {
        //         id: 'Bridal-Shower',
        //         title: 'Bridal Shower',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage7,
        //     }, {
        //         id: 'Proposals',
        //         title: 'Proposals',
        //         description: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        //         img: projectImage7,
        //     }
        // ]
    },
    // {
    //     id: 'Sangeet-Jaggo',
    //     title: 'Sangeet - Jaggo',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage1About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    {
        id: 'Jaggo',
        title: 'Jaggo',
        subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        heading: 'The standard Lorem Ipsum passage, used since the 1500s',
        paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
        images: [projectImage1, projectImage2, projectImage3],
        bnrImg: bnrImg,
        aboutImg: projectImage1About,
        endHeading: 'Creating a sustainable future through building',
        endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    },
    // {
    //     id: 'Haldi-Maiyon',
    //     title: 'Haldi / Maiyon',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage1About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    // {
    //     id: 'Bridal-Shower',
    //     title: 'Bridal Shower',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage1About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    // {
    //     id: 'Proposals',
    //     title: 'Proposals',
    //     subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
    //     heading: 'The standard Lorem Ipsum passage, used since the 1500s',
    //     paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
    //     images: [projectImage1, projectImage2, projectImage3],
    //     bnrImg: bnrImg,
    //     aboutImg: projectImage1About,
    //     endHeading: 'Creating a sustainable future through building',
    //     endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    // },
    {
        id: 'Rentals',
        title: 'Rentals',
        subTitle: 'The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized.',
        heading: 'The standard Lorem Ipsum passage, used since the 1500s',
        paragraph: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit',
        images: [projectImage1, projectImage2, projectImage3],
        bnrImg: bnrImg,
        aboutImg: projectImage1About,
        endHeading: 'Creating a sustainable future through building',
        endSubTitle: 'Designers think everything done by someone else is awful, and that they could do it better themselves, which explains why I designed my own living room carpet, I suppose. the architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.',
    },
]

export const teamMembersDetails = [

    {
        id: 'Gurnish',
        image: memberImage1,
        membername: 'Gurnish',
        position: 'Member',
        facebookUrl: 'https://www.facebook.com',
        twitterUrl: 'https://www.twitter.com',
        instagramUrl: 'https://www.instagram.com',
        linkedinUrl: 'https://in.linkedin.com',
        description: 'Founded by Gurnish, an expert with a degree in color theory, she creates breathtaking works of art that transform your vision into reality. With her expertise, she ensures each design reflects your unique love story. Gurnish’s mission is to provide every couple with a personalized experience, making their dream day truly unforgettable.'
    },
    {
        id: 'Karan',
        image: memberImage2,
        membername: 'Karan',
        position: 'Member',
        facebookUrl: 'https://www.facebook.com',
        twitterUrl: 'https://www.twitter.com',
        instagramUrl: 'https://www.instagram.com',
        linkedinUrl: 'https://in.linkedin.com',
        description: 'Karan is the jack of all trades, expertly managing every aspect of sourcing while also tackling all hands-on tasks. From repairs to installations, his skills and deep logistics knowledge ensures  every project is completed to perfection.'
    },
    {
        id: 'Jashan',
        image: memberImage3,
        membername: 'Jashan',
        position: 'Member',
        facebookUrl: 'https://www.facebook.com',
        twitterUrl: 'https://www.twitter.com',
        instagramUrl: 'https://www.instagram.com',
        linkedinUrl: 'https://in.linkedin.com',
        description: 'Jashan is our creative genius, with a keen eye for detail and a passion for design. His innovative ideas and artistic vision bring your dream event to life. Jashan’s dedication to perfection ensures that every detail is executed flawlessly   '
    },
    {
        id: 'Roop',
        image: memberImage4,
        membername: 'Roop',
        position: 'Member',
        facebookUrl: 'https://www.facebook.com',
        twitterUrl: 'https://www.twitter.com',
        instagramUrl: 'https://www.instagram.com',
        linkedinUrl: 'https://in.linkedin.com',
        description: 'Roop believes in the beauty of meaningful moments. With a background in operations, analytics, and design, she’s excited to bring a touch of luxury to every event. From crafting visual concepts to curating design mockups, her unseen hand brings ideas to life, making each experience unforgettable without being in the spotlight.'
    },
    // {
    //     id: 'Charlie',
    //     image: memberImage1,
    //     membername: 'Charlie',
    //     position: 'Chief Happiness Officer',
    //     facebookUrl: 'https://www.facebook.com',
    //     twitterUrl: 'https://www.twitter.com',
    //     instagramUrl: 'https://www.instagram.com',
    //     linkedinUrl: 'https://in.linkedin.com',
    //     description: 'Meet Charlie, our lovable Chief Happiness Officer! With his wagging tail and endless enthusiasm, Charlie brings a spark of joy to every event. He keeps the team in high spirits, his playful energy is the heart and soul of Sunlight Creationz.'
    // }
]

export const productsDetails = [
    {
        id: 'acrylic-candle-bras',
        image: productImage2,
        title: 'Acryclic Candlebras',
        description: `8 Arms Acrylic Candelabra Centerpieces for,38.5'' Tall Clear Candlesticks Holder with Acrylic Shade with  LED Candles`,
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'yes',
        cutprice: '45.00',
        price: '36.00',
        images: [
            {
                original: productImage2,
                thumbnail: productImage2,
            },
        ]
    },
    {
        id: 'curved-white-cherry-trees',
        image: productImage3,
        title: 'Curved White Cherry Trees',
        description: '2 white curved cherry trees  (6 - 7 feet tall)',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '29.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'gold-candle-bras',
        image: productImage4,
        title: 'Gold Candlebras',
        description: `8 Heads Metal Candelabra Gold Candle  Centerpiece, 38.5'' Tall Candlesticks Holder with LED Candles`,
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '59.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'golden-urli-tub-for-haldi-ceremony',
        image: productImage5,
        title: 'Golden Urli Tub for Haldi Ceremony',
        description: `HALDI THEME FIBERGLASS GOLDEN URLI TUB WITH STOOL, 4x4 Feet`,
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'yes',
        cutprice: '45.00',
        price: '36.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'green-tree-10ft',
        image: productImage6,
        title: 'Green Tree 10ft',
        description: `10 Ft large green banyan tree green leaves artificial tree`,
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '99.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'jaggo-marque-letters',
        image: productImage7,
        title: 'Jaggo Marque Letters',
        description: `3 feet metal marquee color changing letters `,
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '45.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'manja-manjha',
        image: productImage8,
        title: 'Manja Manjha  (CHARPAI)',
        description: '6 x 4 feet (approximately)',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        cutprice: '',
        price: '29.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'pink-white-purple-flower-wall',
        image: productImage9,
        title: 'Pink White Purple Flower Wall',
        description: 'Wedding Flower Wall Panel Backdrop 10 x 10 feet',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '59.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'pipe-and-drape-set',
        image: productImage10,
        title: 'Pipe and Drape Set',
        description: '1-PANEL PIPE AND DRAPE KIT / BACKDROP - 7 - 17  FEET TALL (ADJUSTABLE). Please specify height requirements when renting out.',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '45.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: '10ft-straight-cherry-tree',
        image: productImage11,
        title: '10ft Straight Cherry Tree',
        description: '10 Ft large cherry blossom tree.',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '45.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'sade-munde-da-viah-groom-house-wedding-neon-sign',
        image: productImage12,
        title: 'Sade Munde da Viah Groom House Wedding Neon Sign',
        description: 'Neon sign with wooden stand for grooms weeding house',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '45.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'white-flower-wall',
        image: productImage13,
        title: 'White Flower Wall 10x10 (Neon Sign not included)',
        description: 'Wedding Flower Wall Panel Backdrop 10 x 10 feet',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '45.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
    {
        id: 'acrylic-table',
        image: productImage14,
        title: 'Acrylic Table',
        description: '6-foot clear ghost acrylic table',
        description2: 'Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.',
        sale: 'no',
        cutprice: '',
        price: '36.00',
        images: [
            {
                original: productImage1ImagesOriginal1,
                thumbnail: productImage1ImagesThumbnail1,
            },

        ]
    },
]